export const PERSON_NAME_MAX_LENGTH = 50;

// For first/last person names (User/Tenant owner):
// letters (including accents), hyphens, and apostrophes only.
const PERSON_NAME_REGEX = /^[a-zA-Z\u00C0-\u024F'-]+$/;

export type PersonNameValidationIssue = "required" | "tooLong" | "invalid";

export const validateName = (
  name: string,
  options?: { required?: boolean; maxLength?: number },
): PersonNameValidationIssue | null => {
  const required = options?.required ?? true;
  const maxLength = options?.maxLength ?? PERSON_NAME_MAX_LENGTH;
  const value = (name ?? "").trim();

  if (!value) {
    return required ? "required" : null;
  }

  if (value.length > maxLength) {
    return "tooLong";
  }

  if (!PERSON_NAME_REGEX.test(value)) {
    return "invalid";
  }

  return null;
};
